<template>
  <TextField
    id="mealplan-id"
    :name="`${formNamespace}id`"
    :label="translate(`${LOCALE_PREFIX}.form.planId`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.planIdPlaceholder`)"
    :required="editMealPlan"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { TextField } from '@centric-os/components/src/composed/validators/text-field';
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
